import { List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import _ from "lodash";

const QuantityPicker = ({ onSelect }) => {
  return (
    <List sx={{ pt: 0 }}>
      {_.chain(15).times().map(quantity => quantity + 1).map(quantity => (
        <ListItem disableGutters key={quantity}>
          <ListItemButton onClick={() => onSelect(quantity)}>
            <ListItemText primary={quantity} />
          </ListItemButton>
        </ListItem>
      )).value()}
    </List>
  );
};

export default QuantityPicker;